export const REACT_APP_BUILD_ID = process.env.REACT_APP_BUILD_ID || 'DEV';
